import { render, staticRenderFns } from "./valuebudget.vue?vue&type=template&id=51b4199c&scoped=true&"
import script from "./valuebudget.vue?vue&type=script&lang=js&"
export * from "./valuebudget.vue?vue&type=script&lang=js&"
import style0 from "./valuebudget.vue?vue&type=style&index=0&id=51b4199c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b4199c",
  null
  
)

export default component.exports